const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.165,
    height: 11.999,
    fill: "none",
    viewBox: "0 0 10.165 11.999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.1492 8.1727c1.6936-1.6992 1.6936-4.4543 0-6.1535-1.6936-1.6993-4.4395-1.6993-6.1332 0-1.6936 1.6993-1.6936 4.4543 0 6.1535l3.0666 3.0768z",
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 1.5,
      stroke: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPoint);
export default __webpack_public_path__ + "static/media/icon_edit_point.73bf13286d05056e16e560173c94b946.svg";
export { ForwardRef as ReactComponent };